var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SoftwareDownloading"},[_c('div',{staticClass:"box"},[_c('h5',{staticClass:"isintroduced"},[_vm._v("科普介绍")]),_c('p',{staticClass:"The-text",attrs:{"align":"“left”"},domProps:{"innerHTML":_vm._s(_vm.itemsa.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }